import { createSelector } from 'reselect';

export const selectSearchResults = createSelector(({ office }) => office.searchResults, results => results);

export const getOfficeDefinition = ({ office }) => office.officeDefinition;

export const getInitialValues = ({ office }) => office.initialValues;

export const getCurrentOffice = ({ office }) => office.currentOffice;

export const getLoadingState = ({ office }) => office.isLoading;

export const getDefinitionsLoadingState = ({ office }) => office.isLoadingDefinitions;
